import { styled } from '../../../common/ui'

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media all and (max-width: 600px) {
    display: block;
    > a {
      display: block;
      margin: 0 0 15px 0;
    }
  }
`
